import React, { useEffect, useState } from 'react';
import { Route, useHistory, useLocation } from 'react-router-dom';
import Layout from '../template/app/Layout';
// import ExternalLayout from "../template/external/ExternalLayout";
import { useAppSelector } from '../app/hooks';
import { selectLoginStatus } from '../features/login/loginSlice';
import { isUserType } from '../features/localStorage';
import ExternalLayout from '../template/external/ExternalLayout';

function PrivateRoutes({ path, children }: { path: any; children: any }) {
  // let auth = useAuth();
  const location: any = useLocation();
  const userDetails: any = localStorage.getItem('userDetails');
  let userDetailsJson = JSON.parse(userDetails);
  const [isLogin, setIsLogin] = useState(
    userDetailsJson?.accessToken ? userDetailsJson.accessToken : undefined
  );
  const loginStatus = useAppSelector(selectLoginStatus);
  const history = useHistory();

  let status: any = undefined;

  useEffect(() => {
    const userDetails: any = localStorage.getItem('userDetails');
    if (!userDetails) {
      localStorage.setItem(
        'endpoint',
        !!location?.pathname ? location?.pathname : ''
      );
    }
    if (!userDetails) return;
    let userDetailsJson = JSON.parse(userDetails);
    if (!userDetailsJson?.accessToken) {
      localStorage.setItem(
        'endpoint',
        !!location?.pathname ? location?.pathname : ''
      );
    }
    if (!userDetailsJson) return;
    status = userDetailsJson?.accessToken;
  }, []);
  //console.log(userDetailsJson?.accessToken,"statusstatus")
  //const [checkUserType, setcheckUserType] = useState(isUserType());
  return (
    <>
      {userDetailsJson?.accessToken !== undefined ? (
        <>
          <Layout props={undefined}>
            <Route exact path={path}>
              {children}
            </Route>
          </Layout>
        </>
      ) : (
        <>
          {
            // process.env.REACT_APP_ENV == "local"
            //   ? (window.location.href = "/login")
            //   : (window.location.href = "/login")
            (window.location.href = '/login')
          }
        </>
      )}
    </>
  );
}

export default PrivateRoutes;
